import { Injectable } from '@angular/core';

import { DjangoReloadService } from '@core/services/django-reload.service.interface';
import { Observable, of } from 'rxjs';

@Injectable()
export class NoopDjangoReloadService implements DjangoReloadService {
    constructor() {}

    getDevReload(): Observable<boolean> {
        return of(true);
    }
}
